const TPC_COMPANY = "TPC_Group";
const TPC_LEGACY_BRAND = "TechPerformanceCentre";
const TPC_FINANCE_BRAND = "shared";

export function resolveFinancialWriteCollectionBrand(company, collectionBrand) {
  const companyKey = String(company || "").trim();
  const brand = String(collectionBrand || "").trim();
  if (companyKey === TPC_COMPANY && brand === TPC_LEGACY_BRAND) {
    return TPC_FINANCE_BRAND;
  }
  return brand || TPC_FINANCE_BRAND;
}

export function buildFinancialCallableTenant(tenant = {}) {
  const company = String(tenant.company || "").trim();
  const authCollectionBrand = String(
    tenant.authCollectionBrand || tenant.collectionBrand || "",
  ).trim();
  const collectionBrand = resolveFinancialWriteCollectionBrand(
    company,
    tenant.collectionBrand || authCollectionBrand,
  );
  return {
    ...tenant,
    company,
    collectionBrand,
    authCollectionBrand: authCollectionBrand || tenant.collectionBrand || collectionBrand,
  };
}
